import {USER_REGISTER__DATA} from "../actions";

export default function(state = {}, action) {

  switch (action.type) {
    case USER_REGISTER__DATA:
      //console.log('rdcr_user_register -- USER_REGISTER__DATA -- action.payload', action.payload)
      return action.payload;
    default:
      return state;
  }
}
